import {
	curatorControlConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	//getList
	isSending : false,
	list      : null,

	//find
	findResult      : null,
	findSending     : false,
	changed         : null,
	error           : null,
	restoreSending  : false,
	createIsFailure : null,
	count           : null
}

export default function (state = initialState, action){
	switch (action.type){
		case curatorControlConstants.GetList.REQUEST:
		case curatorControlConstants.Create.REQUEST:
		case curatorControlConstants.Update.REQUEST:
		case curatorControlConstants.Delete.REQUEST:
		case curatorControlConstants.Restore.REQUEST:
		case curatorControlConstants.GetPaged.REQUEST:
			return {
				...state,
				isSending       : true,
				changed         : null,
				createIsFailure : null
			}
		case curatorControlConstants.Find.REQUEST:
			return {
				...state,
				findSending: true
			}
		case curatorControlConstants.GetList.FAILURE:
		case curatorControlConstants.Update.FAILURE:
		case curatorControlConstants.Create.FAILURE:
		case curatorControlConstants.Delete.FAILURE:
		case curatorControlConstants.Restore.FAILURE:
		case curatorControlConstants.GetPaged.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case curatorControlConstants.Find.FAILURE:
			return {
				error       : action.payload,
				findSending : false
			}
		case curatorControlConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}

		case curatorControlConstants.Create.SUCCESS:
			return {
				...state,
				isSending       : false,
				changed         : action.payload.result ? actions.create : null,
				createIsFailure : action.payload.result === false ? 'Проверьте введёные данные!' : null
			}

		case curatorControlConstants.Update.SUCCESS:

			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}

		case curatorControlConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}

		case curatorControlConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}

		case curatorControlConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				listPaged : action.payload.result.items,
				count     : action.payload.result.count
			}

		case curatorControlConstants.Find.SUCCESS:
			return {
				...state,
				findSending : false,
				findResult  : action.payload.result
			}

		case curatorControlConstants.CLEAR:
			return {
				...state,
				changed   : null,
				isSending : false,
				paged     : null,
				list      : null,
				count    	: null,
				listPaged : null
			}
		default:
			return state
	}
}
